var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.menuTreeItem.menu_type != "function"
    ? _c(
        "div",
        [
          (_vm.menuTreeItem.children &&
            _vm.menuTreeItem.children.length >= 1) ||
          _vm.menuTreeItem.haveChildren
            ? _c(
                "el-submenu",
                {
                  key: "submenu" + _vm.menuTreeItem.menu_id,
                  attrs: { index: _vm.menuTreeItem.menu_id.toString() },
                },
                [
                  _c("template", { slot: "title" }, [
                    _vm.menuTreeItem.menu_icon &&
                    _vm.menuTreeItem.menu_icon.indexOf("el-icon-") > -1
                      ? _c("i", { class: _vm.menuTreeItem.menu_icon })
                      : _vm.menuTreeItem.menu_icon &&
                        _vm.menuTreeItem.menu_icon.indexOf("icon-") > -1
                      ? _c("i", {
                          staticClass: "iconfont",
                          class: _vm.menuTreeItem.menu_icon,
                        })
                      : _c("i", {
                          staticClass: "el-icon-star-off",
                          staticStyle: { "font-size": "12px" },
                        }),
                    _vm._v(" "),
                    _vm.collapse
                      ? _c("i", {
                          staticClass: "el-icon-arrow-right menu-has-child",
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                      _vm._v(_vm._s(_vm.menuTreeItem.menu_name)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.getChildrenBadge(_vm.menuTreeItem.children) > 0
                    ? _c("el-badge", {
                        staticStyle: { float: "right" },
                        attrs: {
                          value: _vm.getChildrenBadge(
                            _vm.menuTreeItem.children
                          ),
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-menu-item-group",
                    _vm._l(_vm.menuTreeItem.children, function (item) {
                      return _c("menuTree", {
                        key: item.menu_id,
                        attrs: { menuTreeItem: item },
                      })
                    }),
                    1
                  ),
                ],
                2
              )
            : _c(
                "el-menu-item",
                {
                  key: _vm.menuTreeItem.menu_link,
                  attrs: {
                    index: _vm.menuTreeItem.menu_link,
                    route: "/" + _vm.menuTreeItem.menu_link,
                  },
                },
                [
                  _vm.menuTreeItem.menu_icon &&
                  _vm.menuTreeItem.menu_icon.indexOf("el-icon-") > -1
                    ? _c("i", { class: _vm.menuTreeItem.menu_icon })
                    : _vm.menuTreeItem.menu_icon &&
                      _vm.menuTreeItem.menu_icon.indexOf("icon-") > -1
                    ? _c("i", {
                        staticClass: "iconfont",
                        class: _vm.menuTreeItem.menu_icon,
                      })
                    : _c("i", {
                        staticClass: "el-icon-star-off",
                        staticStyle: { "font-size": "12px" },
                      }),
                  _vm._v(" "),
                  _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v(_vm._s(_vm.menuTreeItem.menu_name)),
                  ]),
                  _vm._v(" "),
                  _vm.getAllBadge(_vm.menuTreeItem.menu_link) > 0
                    ? _c("el-badge", {
                        staticStyle: { float: "right" },
                        attrs: {
                          value: _vm.getAllBadge(_vm.menuTreeItem.menu_link),
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }